import { FormEvent, useState } from 'react';

export function ChangePasswordPanel() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setMessage('');
    setIsError(false);

    if (newPassword.length < 12) {
      setMessage('New password must be at least 12 characters.');
      setIsError(true);
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage('New passwords do not match.');
      setIsError(true);
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch('/api/admin/password', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ currentPassword, newPassword })
      });

      if (!response.ok) {
        setMessage('Password could not be changed.');
        setIsError(true);
        return;
      }

      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setMessage('Password changed.');
    } catch {
      setMessage('Password could not be changed.');
      setIsError(true);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <section className="admin-panel login-panel" aria-labelledby="admin-password-title">
      <div>
        <p className="eyebrow">Security</p>
        <h2 id="admin-password-title">Change Password</h2>
        <p>Replace the current admin password while keeping this session active.</p>
      </div>
      <form className="admin-form" onSubmit={handleSubmit}>
        <label>
          Current password
          <input
            name="currentPassword"
            type="password"
            autoComplete="current-password"
            value={currentPassword}
            onChange={(event) => setCurrentPassword(event.target.value)}
            required
          />
        </label>
        <label>
          New password
          <input
            name="newPassword"
            type="password"
            autoComplete="new-password"
            value={newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
            required
          />
        </label>
        <label>
          Confirm new password
          <input
            name="confirmPassword"
            type="password"
            autoComplete="new-password"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            required
          />
        </label>
        {message ? <p role={isError ? 'alert' : 'status'}>{message}</p> : null}
        <button className="button-primary" type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Changing Password' : 'Change Password'}
        </button>
      </form>
    </section>
  );
}
